import React, { useMemo, useState } from 'react';
import GlobeScene from '../components/globe/GlobeScene';
import ProjectionSelector from '../components/globe/ProjectionSelector';
import ProjectionInfoPanel from '../components/globe/ProjectionInfoPanel';
import DistortionLayer from '../components/globe/DistortionLayer';
import CoordinateInspector from '../components/globe/CoordinateInspector';
import { getProjectionById } from '../utils/projectionCatalog';
import '../styles/GlobeEducation.css';

export default function GlobePage() {
  const [projectionId, setProjectionId] = useState('epsg4326');
  const [showIndicatrix, setShowIndicatrix] = useState(true);
  const [showHeatmap, setShowHeatmap] = useState(false);
  const [inspection, setInspection] = useState(null);

  const projection = useMemo(() => getProjectionById(projectionId), [projectionId]);

  return (
    <div className="gis-education-page">
      <GlobeScene
        projectionId={projectionId}
        showIndicatrix={showIndicatrix}
        showHeatmap={showHeatmap}
        onInspectCoordinate={setInspection}
      />

      <div className="gis-hero-text">
        <h1>GIS Projection Distortion Lab</h1>
        <p>Switch CRS and projections to compare shape, area, and scale distortion in real time.</p>
      </div>

      <div className="gis-overlays">
        <div className="gis-column left">
          <ProjectionSelector
            projectionId={projectionId}
            onProjectionChange={setProjectionId}
            showIndicatrix={showIndicatrix}
            onToggleIndicatrix={setShowIndicatrix}
            showHeatmap={showHeatmap}
            onToggleHeatmap={setShowHeatmap}
          />
          <ProjectionInfoPanel projection={projection} />
        </div>

        <div className="gis-column right">
          <DistortionLayer
            showIndicatrix={showIndicatrix}
            showHeatmap={showHeatmap}
            projectionName={projection.name}
          />
          <CoordinateInspector inspection={inspection} />
        </div>
      </div>

      <div className="viewport-hint">
        Drag to rotate, scroll to zoom, click on Earth to inspect coordinate transformations.
      </div>
    </div>
  );
}
